module.exports = __webpack_public_path__ + "static/lisa-printer-6ac80c1228ea8e4493c5a3119ed8a1af.png";